@if (notification$ | async; as notification) {
  <ng-container>
    <nexweb-deactivation-confirmation-form
      [notification]="notification"
      [labels]="labels"
      [headings]="headings"
      [dateTimeFormat]="dateTimeFormat"></nexweb-deactivation-confirmation-form>
  </ng-container>
}
